import assign from 'lodash/assign';

export default class EditAttendanceController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, attendance, moment,
    StudentService,
    UtilService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.attendance = assign({}, attendance);
    this.moment = moment;
    this.StudentService = StudentService;
    this.UtilService = UtilService;

    this.date = this.moment(this.attendance.date).toDate();
    this.time = this.attendance.startTime;
    this.text = 'rejestrację';

    if (this.attendance.endTime) {
      this.endTime = this.attendance.endTime;
      this.text = 'frekwencję';
    }
  }

  edit(form) {
    if (form.$invalid) {
      return false;
    }

    this.editAttendance(this.attendance).then(() => {
      this.$mdDialog.hide(this.attendance);
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Zmieniono ' + this.text)
          .position('bottom right')
          .hideDelay(3000)
      );
    })
      .catch(error => {
        this.$mdDialog.cancel();
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }

  delete() {
    this.StudentService.deleteAttendance(this.attendance.student.id, this.attendance.id)
      .then(() => {
        this.$mdDialog.hide();
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Usunięto ' + this.text)
            .position('bottom right')
            .hideDelay(3000)
        );
      })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }

  editAttendance(attendance) {
    this.attendance.date = this.moment(this.date).format('YYYY-MM-DD').toString();
    this.attendance.startTime = this.time;
    if (this.attendance.endTime) {
      this.attendance.endTime = this.endTime;
    }

    return this.StudentService.editAttendanceRegistration(attendance);
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}
